import { useSuspenseQuery } from "@tanstack/react-query";
import { type FC, Suspense } from "react";
import { Api } from "../../api.config";
import { useCompany } from "../../company/useCompany";
import { QueryKeys } from "../../LinkGen";

const DisapprovedAdsBannerInner: FC<{
	onShowDisapproved: () => void;
}> = ({ onShowDisapproved }) => {
	const company = useCompany();
	const { data: disapprovedAds } = useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Reporting.Disapproved(company.id),
		queryFn: () => Api.GetMetaAdsDisapprovedAds().then((r) => r.data),
		refetchInterval: 3600000,
	});

	if (disapprovedAds.length === 0) return null;

	return (
		<div
			className="alert alert-danger"
			style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
			}}
		>
			<span>
				<strong>{disapprovedAds.length}</strong> disapproved ad
				{disapprovedAds.length !== 1 ? "s" : ""} detected. Review and fix policy
				violations.
			</span>
			<button
				type="button"
				className="btn btn-sm btn-outline-danger"
				onClick={onShowDisapproved}
			>
				View Disapproved Ads
			</button>
		</div>
	);
};

export const DisapprovedAdsBanner: FC<{
	onShowDisapproved: () => void;
}> = (props) => (
	<Suspense fallback={null}>
		<DisapprovedAdsBannerInner {...props} />
	</Suspense>
);
